import { atom, useAtom } from "jotai";
import { ProductionSegmentType } from "types/types";

type TimelineTooltipStore = {
  isModalPinned: boolean;
  modal: {
    t: number;
    clickIndex: number;
  } | null;
  selectedProdSegment: ProductionSegmentType | null;
  machemetryId: string | null;
  selectedTimelineIdx: number | null;
};
const timelineTooltipAtom = atom<TimelineTooltipStore>({
  isModalPinned: false,
  modal: null,
  selectedProdSegment: null,
  machemetryId: null,
  selectedTimelineIdx: null,
});
export const useTimelineTooltipStore = () => {
  return useAtom(timelineTooltipAtom);
};
